"use strict";

var _asyncToGenerator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return generator._invoke = function (innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; }(innerFn, self, context), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; this._invoke = function (method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) { if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; } return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (object) { var keys = []; for (var key in object) { keys.push(key); } return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) { "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); } }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _types = _interopRequireDefault(require("../types"));

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.scan = scan, exports.Scanner = void 0;
/**
* @module radspec/scanner
*/

/**
* Enum for scanner state.
*
* @readonly
* @enum {string}
*/

var SCANNER_STATE = {
  OK: "OK",
  ERROR: "ERROR"
};
/**
* A scanner that identifies tokens in a source string.
*
* @class Scanner
* @param {string} source The source code
* @property {string} state The state of the parser (`OK` or `ERROR`)
* @property {string} source The source code
* @property {number} cursor
* @property {Array<Token>} tokens The currently identified tokens
*/

var Scanner = /*#__PURE__*/function () {
  function Scanner(source) {
    _classCallCheck(this, Scanner);

    this.state = SCANNER_STATE.OK, this.isInExpression = !1, this.source = source, this.cursor = 0, this.tokens = [];
  }
  /**
  * Scans a single token from source and pushes it to `Scanner.tokens`.
  *
  * @return {void}
  */


  _createClass(Scanner, [{
    key: "scanToken",
    value: function scanToken() {
      var current = this.consume();
      if ("`" === current) return this.isInExpression = !this.isInExpression, void this.emitToken("TICK"); // We haven't hit a tick yet, so we're not in an expression

      if (!this.isInExpression) {
        // Scan until tick
        var monologue = current;

        for (; "`" !== this.peek() && !this.eof();) {
          monologue += this.consume();
        }

        return void this.emitToken("MONOLOGUE", monologue);
      }

      switch (current) {
        // Single character tokens
        case "(":
          this.emitToken("LEFT_PAREN");
          break;

        case ")":
          this.emitToken("RIGHT_PAREN");
          break;

        case ",":
          this.emitToken("COMMA");
          break;

        case ".":
          this.emitToken("DOT");
          break;

        case ":":
          this.emitToken("COLON");
          break;

        case "-":
          this.emitToken("MINUS");
          break;

        case "+":
          this.emitToken("PLUS");
          break;

        case "^":
          this.emitToken("POWER");
          break;

        case "*":
          this.emitToken("STAR");
          break;

        case "/":
          this.emitToken("SLASH");
          break;

        case "%":
          this.emitToken("MODULO");
          break;

        case "?":
          this.emitToken("QUESTION_MARK");
          break;

        case "@":
          this.emitToken("AT");
          break;
        // One or two character tokens

        case "!":
          this.emitToken(this.matches("=") ? "BANG_EQUAL" : "BANG");
          break;

        case "=":
          this.emitToken(this.matches("=") ? "EQUAL_EQUAL" : "EQUAL");
          break;

        case "<":
          this.emitToken(this.matches("=") ? "LESS_EQUAL" : "LESS");
          break;

        case ">":
          this.emitToken(this.matches("=") ? "GREATER_EQUAL" : "GREATER");
          break;
        // Two character tokens

        case "|":
          this.matches("|") ? this.emitToken("DOUBLE_VERTICAL_BAR") : this.report("Unexpected single \"|\" (expecting two)");
          break;
        // Whitespace

        case " ":
        case "\r":
        case "\n":
        case "\t":
          break;
        // Multi-character tokens

        default:
          var NUMBERS = /[0-9]/;

          if (NUMBERS.test(current)) {
            var number = current,
                type = "NUMBER"; // Detect hexadecimals

            if ("0" === current && "x" === this.peek()) for (type = "HEXADECIMAL", number += this.consume(); /[0-9a-f]/i.test(this.peek());) {
              number += this.consume();
            } else for (; NUMBERS.test(this.peek());) {
              number += this.consume();
            }
            this.emitToken(type, number);
            break;
          }

          var IDENTIFIERS = /[_$a-z0-9]/i;

          if (IDENTIFIERS.test(current)) {
            var identifier = current;

            for (; IDENTIFIERS.test(this.peek());) {
              identifier += this.consume();
            }

            if ("true" === identifier || "false" === identifier) {
              this.emitToken("BOOLEAN", identifier);
              break;
            }

            _types.default.isType(identifier) ? this.emitToken("TYPE", identifier) : this.emitToken("IDENTIFIER", identifier);
            break;
          }

          if ("'" === current || "\"" === current) {
            var string = "";

            for (; !this.matches("'") && !this.matches("\"");) {
              string += this.consume();
            }

            this.emitToken("STRING", string);
            break;
          }

          this.report("Unexpected character \"".concat(current, "\""));
      }
    }
    /**
    * Push a token to `Scanner.tokens`
    *
    * @param {string} type The token type
    * @param {string?} value The token value
    * @return {void}
    */

  }, {
    key: "emitToken",
    value: function emitToken(type, value) {
      var token = {
        type: type
      };
      value && (token.value = value), this.tokens.push(token);
    }
    /**
    * Get the current character and increase the cursor by 1
    *
    * @return {string}
    */

  }, {
    key: "consume",
    value: function consume() {
      return this.cursor++, this.source[this.cursor - 1];
    }
    /**
    * Get the character under the cursor without consuming it.
    *
    * @return {string}
    */

  }, {
    key: "peek",
    value: function peek() {
      return this.source[this.cursor];
    }
    /**
    * Checks if the next character matches an expected one.
    *
    * Increases the cursor by 1 if the character matches.
    *
    * @param {string} expected The character to expect
    * @return {boolean} True if the next character matches, otherise false
    */

  }, {
    key: "matches",
    value: function matches(expected) {
      return !this.eof() && !(this.peek() !== expected) && (this.cursor++, !0);
    }
    /**
    * Scans source and returns a list of tokens.
    *
    * @return {Array<Token>}
    */

  }, {
    key: "scan",
    value: function () {
      var _scan = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                for (; !this.eof();) {
                  this.scanToken();
                }

                return _context.abrupt("return", this.state === SCANNER_STATE.ERROR ? void console.error("Errors encountered while scanning source") : this.tokens);

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function scan() {
        return _scan.apply(this, arguments);
      }

      return scan;
    }()
    /**
    * Returns true if we've reached the end of source, otherwise false.
    *
    * @return {boolean}
    */

  }, {
    key: "eof",
    value: function eof() {
      return this.cursor >= this.source.length;
    }
    /**
    * Prints an error with location information to `stderr`
    * and sets the scanner state to `SCANNER_STATE.ERROR`
    *
    * @param {string} error
    * @return {void}
    */

  }, {
    key: "report",
    value: function report(error) {
      this.state = SCANNER_STATE.ERROR, console.error("Error (".concat(this.cursor, "): ").concat(error));
    }
  }]);

  return Scanner;
}();
/**
* Scans source and returns a list of tokens.
*
* @memberof radspec/scanner
* @param  {string} source
* @return {Array<Token>}
*/


exports.Scanner = Scanner;

function scan(source) {
  return new Scanner(source).scan();
}